<div hidden>
    <ng-template #loading>
        <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
    </ng-template>
</div>
<div class="card" fullscreen>
    <div hidden>
        <div>
            <mat-checkbox
                id="cbxColumnHeader"
                #cbxColumnHeader
                [(ngModel)]="selectedRowsCheckbox.checked"
                [(indeterminate)]="selectedRowsCheckbox.indeterminate"
            ></mat-checkbox>
        </div>
    </div>
    <p-accordion [multiple]="true">
        <!-- <p-accordionTab header="Filters" [selected]="false">
            <form
                [formGroup]="filterFormGroup"
                #filterForm="ngForm"
                id="filterForm"
            >
                <p-toolbar>
                    <button
                        pButton
                        pRipple
                        label="Clear"
                        class="p-button-text"
                        (onClick)="clearFilters()"
                    ></button>

                    <div class="p-float-label">
                        <p-multiSelect
                            [virtualScroll]="true"
                            itemSize="32"
                            *ngIf="entryDates as items; else loading"
                            appendTo="body"
                            [options]="items | orderBy: 'EmployeeName'"
                            optionLabel="EmployeeName"
                            [filter]="true"
                            selectedItemsLabel="{0} Users(s) selected."
                            formControlName="users"
                            dataKey="EmployeeListId"
                        >
                        </p-multiSelect>
                        <label for="ddlUser">Users</label>
                    </div>

                    <div class="p-float-label">
                        <p-multiSelect
                            [virtualScroll]="true"
                            itemSize="32"
                            *ngIf="groups as items; else loading"
                            [options]="items | orderBy: 'GroupName'"
                            optionLabel="GroupName"
                            [filter]="true"
                            selectedItemsLabel="{0} Groups(s) selected."
                            formControlName="groups"
                            dataKey="GroupID"
                            appendTo="body"
                        >
                        </p-multiSelect>
                        <label for="ddlUser">Groups</label>
                    </div>
                </p-toolbar>
            </form>
        </p-accordionTab> -->

        <p-accordionTab header="Update Multiple Dates" [selected]="true">
            <form
                [formGroup]="multiUpdateFormGroup"
                #updateForm="ngForm"
                id="multi"
            >
                <p-toolbar>
                    <div style="padding-right: 1vw">
                        <p-datepicker
                            formControlName="startDate"
                            [showIcon]="true"
                            [readonlyInput]="false"
                            appendTo="body"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            yearRange="2000:2030"
                        ></p-datepicker>
                    </div>

                    <div style="padding-right: 1vw">
                        <p-datepicker
                            formControlName="endDate"
                            [showIcon]="true"
                            [readonlyInput]="false"
                            appendTo="body"
                            [monthNavigator]="true"
                            [yearNavigator]="true"
                            yearRange="2000:2030"
                        >
                        </p-datepicker>
                    </div>
                    <div>
                        <button
                            pButton
                            id="applyMulti"
                            label="Apply"
                            icon="pi pi-check"
                            severity="primary"
                            iconPos="left"
                            #applyMulti
                            (click)="multiUpdate()"
                        ></button>
                    </div>
                </p-toolbar>
            </form>
        </p-accordionTab>
    </p-accordion>

    <div class="table-container" style="margin-top: 1em;">
        <p-table stripedRows #UEDTable [scrollable]="true" scrollDirection="both" [style]="{ 'max-width': '100%' }" scrollHeight="65vh"
            [value]="entryDates" editMode="row" (onEditInit)="onEditInit($event)" [(selection)]="uedTableSelection"
            (onRowEditSave)="onRowEditSave($event)" dataKey="EmployeeListId">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="17" style="text-align: center">
                        <div class="tabulator-placeholder">
                            <span> No Data Available </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header">
                <tr class="tabulator-header">
                    <th class="tabulator-colgroup-header p-header-cell edit-cell"></th>
                    <th style="text-align: center" class="tabulator-colgroup-header p-header-cell status-cell">
                        <i class="pi pi-exlamation-circle" title="Status"></i>
                    </th>
                    <th
                        style="text-align: center"
                        class="tabulator-colgroup-header select-cell p-header-cell"
                    >
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th pSortableColumn="EmployeeName" class="tabulator-colgroup-header p-header-cell large-cell">
                        Name
                        <p-sortIcon field="EmployeeName" ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order">
                        </p-sortIcon>
                        <p-columnFilter field="EmployeeListId" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                            <ng-template #filter let-value let-filter="filterCallback">
                                <p-multiSelect
                                    class="filter"
                                    defaultLabel="Filter"
                                    appendTo="body"
                                    [options]="employeeSelectItem | orderBy: 'EmployeeName'"
                                    [filter]="true"
                                    [ngModel]="value"
                                    (ngModelChange)="filter($event)"
                                    styleClass="w-full"
                                >
                                </p-multiSelect>
                            </ng-template>
                        </p-columnFilter>
                    </th>
                    <th  pSortableColumn="Splitday" class="tabulator-colgroup-header p-header-cell small-cell">
                        <div class="tabulator-col-content">
                            Split Day
                            <p-sortIcon field="Splitday" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="MinWorkDate"  class="tabulator-colgroup-header p-header-cell small-cell">
                        <div class="tabulator-col-content">
                            Start Date
                            <p-sortIcon field="MinWorkDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="MaxWorkDate"  class="tabulator-colgroup-header p-header-cell small-cell">
                        <div class="tabulator-col-content">
                            End Date
                            <p-sortIcon field="MaxWorkDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </div>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-ued let-edit="editing" let-ri="rowIndex">
                <tr class="tabulator-row" [pEditableRow]="ued">
                    <td class="p-datatable-cell edit-cell" style="text-align: center; align-items: center">
                        <button *ngIf="
                                !edit &&
                                (!editing?.EmployeeListId ||
                                    !editing?.EmployeeListId ===
                                        ued?.EmployeeListId)
                            " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                            (click)="onRowEditInit(ued)" class="p-button-rounded p-button-text"
                            style="height: 1.4rem; width: 1.4rem" title="Edit"></button>
                        <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                            (click)="onRowEditSave(ued)" class="
                                p-button-rounded
                                p-button-text
                                p-button-success
                            " style="
                                margin-right: 0.5em;
                                height: 1.4rem;
                                width: 1.4rem;
                            "></button>
                        <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                            (click)="onRowEditCancel(ued)" class="
                                p-button-rounded
                                p-button-text
                                p-button-danger
                            " style="height: 1.4rem; width: 1.4rem"></button>
                    </td>
                    <td class="p-datatable-cell status-cell">
                        <div style="height: 2em; align-self: center">
                            <a (click)="onStatusClick(ued)">
                                <div>
                                    <ef-status-icon [status]="
                                            ued?.Status?.StatusCode
                                        " [message]="
                                            ued?.Status?.Message
                                        "></ef-status-icon>
                                </div>
                            </a>
                        </div>
                    </td>
                    <td
                        class="p-datatable-cell select-cell"
                        style="text-align: center"
                    >
                        <p-tableCheckbox [value]="ued"></p-tableCheckbox>
                    </td>
                    <td class="p-datatable-cell large-cell">
                        {{ued.EmployeeName}}
                    </td>
                    <td class="p-datatable-cell small-cell">
                        {{ued.Splitday}}
                    </td>
                    <td class="p-datatable-cell small-cell">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-datepicker
                                    [(ngModel)]="minWorkDate"

                                    appendTo="body"
                                    [yearNavigator]="true"
                                    [monthNavigator]="true"
                                    yearRange="2010:2030"
                                ></p-datepicker>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{moment(ued.MinWorkDate).format('MM/DD/YYYY')}}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td class="p-datatable-cell small-cell">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <p-datepicker
                                    [(ngModel)]="maxWorkDate"

                                    appendTo="body"
                                    [yearNavigator]="true"
                                    [monthNavigator]="true"
                                    yearRange="2010:2030"
                                ></p-datepicker>
                            </ng-template>
                            <ng-template pTemplate="output">
                               {{moment(ued.MaxWorkDate).format('MM/DD/YYYY')}}
                            </ng-template>
                        </p-cellEditor>
                    </td>
                </tr>
            </ng-template>
        </p-table>
        <!-- <div style="display: block" class="mat-content">
            <div style="width: 95vw; float: left">
                <div
                    class="alternate-text"
                    style="
                        float: left;
                        padding-bottom: 0.5vh;
                        padding-top: 0.5vh;
                    "
                    [hidden]="!tabEntryDates"
                >
                    <div
                        style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            flex-wrap: wrap;
                            justify-content: left;
                        "
                    >
                        <button
                            class="p-button-text p-button-secondary"
                            [disabled]="
                                !tabEntryDates?.getSelectedData()?.length
                            "
                            (click)="clearSelectedRows()"
                            #clearSelection
                            label="Clear Selection"
                        >
                            Clear Selection
                        </button>
                        <span style="padding-right: 1vw">
                            {{ tabEntryDates?.getSelectedData()?.length }} rows
                            selected.
                        </span>

                        <span
                            id="divSelectAll"
                            class="fade show"
                            style="display: none; clear: none"
                            [hidden]="
                                tabEntryDates?.getSelectedData(true)?.length ==
                                    0 || !this.cbxColumnHeader.checked
                            "
                        >
                        </span>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <div>
            <div [hidden]="!loadingData" class="page-overlay">
                <div class="page-overlay-content">
                    <div *ngIf="loadingData; then loading"></div>
                </div>
            </div>
            <div id="tabEntryDates"></div>
        </div>
        <div
            class="page-overlay"
            #tabOverlay
            id="tabOverlay"
            tabindex="0"
            style="display: none"
        ></div> -->
    </div>

    <!--<div id="tabEntryDates"></div>-->
</div>
